import { observable, action, makeObservable } from 'mobx';

import type { Optional } from 'chaika-common-types';
import { TitleParams } from '@components/Tabs';

export interface NavigationTabsParams {
    titleParams: TitleParams[];
    activeIndex: number;
    fixedPosition?: boolean;
    onTabClick(tabIndex: number): void;
}

export class NavigationTabs {
    @observable
    public titleParams!: TitleParams[];

    @observable
    public activeIndex = 0;

    @observable
    public onTabClick!: (tabIndex: number) => void;

    constructor() {
        makeObservable(this);
    }

    public getActiveTitleParams(): Optional<TitleParams> {
        return this.titleParams && this.titleParams[this.activeIndex];
    }

    @action
    public reset(): void {
        // @ts-ignore
        this.titleParams = undefined;
        this.activeIndex = 0;
        // @ts-ignore
        this.onTabClick = undefined;
    }

    @action
    public setNavigationTabs({ titleParams, activeIndex, onTabClick }: NavigationTabsParams): void {
        this.titleParams = titleParams;
        this.activeIndex = activeIndex;
        this.onTabClick = onTabClick;
    }

    @action
    public setActiveIndex(activeIndex: number): void {
        this.activeIndex = activeIndex;
    }
}
